module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/app-download-appstore-80aad269a31b6051287bca5c26846f1a.png";